import React from 'react'
import { useParams } from 'react-router-dom'

import { isDigitalFulfillment } from '../Product.utils'
import { useOfferQuery } from '../hooks'
import { ProductSectionsView } from './ProductSectionsView'
import { useUpdateOfferSectionsMutation } from './mutations/useUpdateOfferSectionsMutation'
import type { ProductSectionsViewProps } from './types'

export const ProductSectionsContainer = () => {
  const { productId = '' } = useParams<'productId'>()
  const { offerQuery, setOfferData } = useOfferQuery([productId])

  const productIsFetching = offerQuery.isLoading
  const sections = offerQuery.data?.additionalSections || []
  const productName = offerQuery.data?.name
  const fulfillmentService = offerQuery.data?.fulfillingService || 'FULFILLED_BY_CREATOR'
  const isDigital = isDigitalFulfillment(fulfillmentService)
  const { updateOfferSectionsMutation } = useUpdateOfferSectionsMutation()

  const handleSubmit: ProductSectionsViewProps['onSubmit'] = (payload) => {
    updateOfferSectionsMutation.mutate([{ offerId: productId }, payload], {
      onSuccess: (data) => {
        setOfferData(data)
      },
    })
  }

  return (
    <ProductSectionsView
      sections={sections}
      productName={productName}
      productId={productId}
      isDigital={isDigital}
      productIsFetching={productIsFetching}
      onSubmit={handleSubmit}
    />
  )
}
